import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import TopTabNavigationLink from './topTabNavigationLink';
import defaultClasses from './topTabNavigation.module.css';
import Icon from '../Common/Icon/icon';
import arrow from '../../assets/arrow.svg';
import { useMergeCssClasses } from '../../Utils/utils';
import { Link } from 'react-router-dom';

var TopTabNavigation = function TopTabNavigation(_ref) {
  var navLinks = _ref.navLinks,
      activeTab = _ref.activeTab,
      handleActiveTab = _ref.handleActiveTab,
      propClasses = _ref.classes,
      isResourcePage = _ref.isResourcePage;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDropdownOpen = _useState2[0],
      setIsDropdownOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      activeTabTitle = _useState4[0],
      setActiveTabTitle = _useState4[1];

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;
  var dropdownRef = useRef();
  var tabsRef = useRef();
  var classes = useMergeCssClasses(defaultClasses, propClasses);
  useEffect(function () {
    if (activeTab) navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (item) {
      return item.id === activeTab && setActiveTabTitle(item);
    });
  }, [activeTab]);
  useEffect(function () {
    return (tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) && setTimeout(function () {
      var _tabsRef$current;

      return window.scroll({
        top: ((_tabsRef$current = tabsRef.current) === null || _tabsRef$current === void 0 ? void 0 : _tabsRef$current.offsetTop) - 80,
        behavior: 'smooth'
      });
    }, 100);
  }, [tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current]);

  var toggleDropdown = function toggleDropdown() {
    return setIsDropdownOpen(function (prevState) {
      return !prevState;
    });
  };

  var topNavigationClasses = isResourcePage ? classes.linkListWrapper : classes.linkListWrapper_active;
  var links = !isSmallDevice && React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    className: topNavigationClasses
  }, React.createElement("ul", {
    className: classes.linkList,
    id: "links-wrapper"
  }, navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (item) {
    return item.title === 'Custom Quote Request Form' ? React.createElement("li", {
      className: "".concat(classes.link, " ").concat(classes.linkListItem)
    }, React.createElement(Link, {
      to: "/custom-product-request-form",
      "aria-label": "Go to quote request form"
    }, "Custom Quote Request Form")) : React.createElement(TopTabNavigationLink, {
      key: item.id,
      item: item,
      active: item.id === activeTab,
      handleActiveTab: handleActiveTab,
      classes: {
        linkListItem: classes.linkListItem
      },
      isResourcePage: isResourcePage
    });
  }))));
  var smallDeviceLinks;

  if (isSmallDevice) {
    smallDeviceLinks = React.createElement("div", {
      className: "container"
    }, React.createElement("div", {
      className: classes.dropdown,
      onClick: toggleDropdown
    }, React.createElement("span", {
      className: classes.dropdownTitle
    }, activeTabTitle === null || activeTabTitle === void 0 ? void 0 : activeTabTitle.title), React.createElement("button", {
      onClick: toggleDropdown,
      className: isDropdownOpen ? "".concat(classes.iconActive) : '',
      "aria-label": "Toggle dropdown"
    }, React.createElement(Icon, {
      src: arrow,
      alt: isDropdownOpen ? 'Dropdown arrow up' : 'Dropdown arrow down',
      onClick: toggleDropdown
    })), React.createElement("div", {
      className: classes.dropdownContent,
      ref: dropdownRef,
      style: isDropdownOpen ? {
        height: dropdownRef.current.scrollHeight,
        transition: 'height 0.25s ease-out',
        overflow: 'hidden'
      } : {
        height: '0px',
        transition: 'height 0.25s ease-out',
        overflow: 'hidden'
      }
    }, navLinks.map(function (item, idx) {
      return item.id !== activeTab && React.createElement("span", {
        key: idx,
        className: classes.dropdownLink,
        onClick: function onClick() {
          return handleActiveTab(item.id);
        }
      }, item.title);
    }))));
  }

  return React.createElement("div", {
    ref: tabsRef
  }, links, smallDeviceLinks);
};

export default TopTabNavigation;